import React from 'react';
import { Box, Button, Grid, Paper } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { modalSelector } from 'redux/selectors';
import styled from 'styled-components';

import { CheckCircleFill } from '@styled-icons/bootstrap';

const StyledPaper = styled(Paper)`
  padding: 3rem;
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  border: 2px solid #000;
  box-shadow: ${(p) => p.theme.shadows[5]};
`;

const Icon = styled(CheckCircleFill)`
  width: 2rem;
  height: 2rem;
  color: green;
`;

const defaultHeader = 'La operación ha sido realizada con éxito';
const defaultContent = 'Contenido';
const defaultButtons = [
  { variant: 'contained', color: 'secondary', text: 'Salir' },
  { variant: 'contained', color: 'primary', text: 'Aceptar' },
];

function SuccessModal() {
  // getModalStyle is not a pure function, we roll the style only on the first render
  const { modalProps = {} } = useSelector(modalSelector);
  const {
    header = defaultHeader,
    content = defaultContent,
    buttons = defaultButtons,
  } = modalProps;

  return (
    <StyledPaper elevation={3}>
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="stretch"
        spacing={4}
      >
        <Grid item>
          <Icon />
        </Grid>
        <Grid item>{header}</Grid>
        <Grid item>{content}</Grid>
        <Grid item>
          <Box>
            {buttons.map((button) => {
              return (
                <Button variant={button.variant} color={button.color}>
                  {button.text}
                </Button>
              );
            })}
          </Box>
        </Grid>
      </Grid>
    </StyledPaper>
  );
}

export default SuccessModal;
